import { Box } from "@mui/material";
import styled from "styled-components";

export const ContactInfoFormStyled = styled(Box)`
  .detail-template {
    display: grid;
    height: 100%;
    grid-template-columns: 60% calc(40% - 16px);
    gap: 16px;
  }

  .flex {
    display: flex;
    gap: 16px;
    padding-bottom: 24px;
  }

  .flexCreate {
    display: flex;
    gap: 10px;
    padding-bottom: 16px;
  }

  .company-cont {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
    column-gap: 20px;
  }

  .row-style {
    min-height: ${(props) => (props?.isGroupDetailView ? "87px" : "150px")};
    border-radius: 5px;
  }

  .checkbox-wrapper {
    display: flex;
    gap: 10px;
    margin-top: 30px;
    margin-left: 12px;

    .MuiFormControlLabel-root {
      height: 35px;
      border: 1px solid rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      width: 50%;
      background-color: white;
    }
  }

  .hr {
    border-bottom: 1px solid #dedafb !important;
    border: none;
    margin: 8px 0px 16px 0px;
  }

  .left-content {
    display: flex;
    flex-direction: column;

    .label {
      margin-bottom: 8px !important;
      height: 23px;
    }
  }

  .notes {
    display: flex;
    flex-direction: column;

    .label {
      margin-bottom: 8px;
      height: 23px;
    }
  }
`;

